import { render, staticRenderFns } from "./fixGoods.vue?vue&type=template&id=fac0a9d2&scoped=true&"
import script from "./fixGoods.vue?vue&type=script&lang=js&"
export * from "./fixGoods.vue?vue&type=script&lang=js&"
import style0 from "./fixGoods.vue?vue&type=style&index=0&id=fac0a9d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac0a9d2",
  null
  
)

export default component.exports